import React, { FC } from 'react';
import { AxisPositions } from '../../../../constans/modal.constants';
import { SCRIPT_TAG_ESCAPE_REG_EXP } from '../../../../constans/regex-constants';
import { IModalBodyProps } from '../modal';

const ModalBody: FC<Partial<IModalBodyProps>> = (props: Partial<IModalBodyProps>) => {
  const escapeValidatedString = props.htmlString?.replace(SCRIPT_TAG_ESCAPE_REG_EXP, '');
  const contentAlign = props.contentAlign || AxisPositions.CENTER;
  const modalBodyClassName = `modal-body ${contentAlign}`;

  return (
    <>
      {props.customBody
        ? <>{props.customBody}</>
        : <div className={modalBodyClassName} dangerouslySetInnerHTML={{ __html: escapeValidatedString || props.bodyText || '' }}/>
      }
    </>
  );
};

export default ModalBody;
